$(window).scroll(function() {
    var offset = $(this).scrollTop();

    if (offset > 100) {
        $('body').addClass('sticky-up');
    } else {
        $('body').removeClass('sticky-up');
    }

    if (offset > 800) {
        $('body').removeClass('sticky-up');
        $('body').addClass('menu-is-sticky');
    } else {
        $('body').removeClass('menu-is-sticky');
    };

});
